import { orgSelectors } from 'ducks/orgs'
import { Alert } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useStripeCustomerSurchargeConfigured } from 'util/cashFlow/configuration'

type PropTypes = {
  surchargingEnabled: boolean
  isConfigured?: boolean
  isLoading?: boolean
}

const StripeSurchargingConfigWarning: React.FC<PropTypes> = ({
  surchargingEnabled,
  isConfigured: isConfiguredProp,
  isLoading: isLoadingProp,
}) => {
  const translate = useTranslate()
  const isStripePsp = useSelector(orgSelectors.getIsCashflowStripePsp)
  const { isConfigured: hookIsConfigured, isLoading: hookIsLoading } = useStripeCustomerSurchargeConfigured(
    isConfiguredProp === undefined && isLoadingProp === undefined && surchargingEnabled
  )
  const isConfigured = isConfiguredProp ?? hookIsConfigured
  const isLoading = isLoadingProp ?? hookIsLoading

  if (!surchargingEnabled || !isStripePsp || isLoading || isConfigured) {
    return null
  }

  return (
    <Alert severity="warning">
      <span>
        {translate('To fully enable surcharging please configure your surcharging rate in the')}{' '}
        <Link to="/cashflow/stripe_settings" target="_blank" rel="noopener noreferrer">
          {translate('Stripe Payment Settings page')}
        </Link>
      </span>
    </Alert>
  )
}

export default StripeSurchargingConfigWarning
